<template>
  <div>
    <div class="person-consultant">
      <div class="person-wrapper">
        <div class="person-picture" >
          <img :src="counselorInfo.logoUrl" alt="">
        </div>
        <div class="person-content">
          <h2>
            <span class="name">{{counselorInfo.name}}</span>
            <span class="job">{{counselorInfo.profession}}</span>
          </h2>
          <div class="main">
              <p class="adept">擅长：{{[].concat(counselorInfo.skills).join(' | ')}}</p>
          </div>
        </div>
      </div>
      <div class="person-contact">
        <div class="appointment pull-left" @click.stop="onclick">
          <span>预约贷款服务</span>
        </div>
        <ul class="pull-left">
          <li class="pull-left"><span class="iconfont">&#xe614;</span><span class="phone">{{counselorInfo.phone}}</span></li>
          <li class="pull-left" style="margin-top: 1px"><span class="iconfont">&#xe615;</span><span class="wechat">{{counselorInfo.wechat}}</span></li>
          <li class="pull-left" style="margin-top: 2px"><span class="iconfont">&#xe616;</span><span class="qq">{{counselorInfo.qq}}</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import Modal from '../modal/modal2'
  export default {
    components: {
      Modal
    },
    props: {
      counselorId: {
        type: String,
        required: true
      },
      typeList: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        counselorInfo: {}
      }
    },
    created () {
      this._fetchCounselorInfo()
    },
    methods: {
      /**
       * 获取个人详情
       * @param loanType
       * @private
       */
      _fetchCounselorInfo () {
        let vm = this
        this.$ajax({
          url: '/getCounselorInfo.jhtml',
          params: {
            counselorId: vm.counselorId
          },
          done (info) {
            vm.counselorInfo = info || {}
          }
        })
      },
      // 获取擅长文本内容
     /* getSkillMap (skillScore) {
        let skill = []
        this.typeList.forEach(type => {
          if ((skillScore & type.code) === type.code) {
            skill.push(type.name)
          }
        })
        return skill
      }, */
      // 贷款预约统计
      onclick () {
        this.$emit('show-modal')
        let vm = this
        let from = vm.$route.path.split('/').some(str => str === 'article') ? 'article' : 'counselor'
        let articleId = vm.$route.query.id || ''
        this.$ajax({
          url: '/loanReservationStatistics.jhtml',
          params: {
            from: from,
            counselorId: vm.counselorId,
            articleId: articleId
          }
        })
//        if (!this.$cache.getUserToken()) {
//          vm.$router.push('/auth/login')
//        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .person-consultant
    background url(../../../static/images/bg-consultor.jpg) no-repeat top left
    background-size 100%
    height px2rem(320)
    padding px2rem(34) px2rem(20) px2rem(34)
    .person-picture
      float left
    .person-picture img
      margin 0 px2rem(28) px2rem(17) 0
      height px2rem(210)
      width  px2rem(166)
      box-shadow 0 px2rem(1) px2rem(24) 0 rgba(33, 70, 104, 1)
    .person-wrapper:after,
    .person-contact:after
      content '.'
      display block
      clear both
      height 0
      visibility: hidden
    .person-content
      float left
      height px2rem(210)
      border-bottom 1px solid rgba(255,255,255,.2)
    .person-content h2
      margin 0
      color white
      margin-bottom px2rem(18)
      max-width px2rem(516)
    .person-content span
      margin 0
      display inline-block
    .person-content .name
      font-size px2rem(32)
      line-height px2rem(32)
      margin-right px2rem(29)
      font-weight 900
      max-width px2rem(150)
      padding-top px2rem(4)
      ellipsis()
    .person-content .job
      max-width px2rem(160)
      font-size px2rem(18)
      padding-top px2rem(4)
      ellipsis()
    .person-content .main
      width px2rem(516)
      margin 0
      color white
      font-size px2rem(22)
      line-height px2rem(35)
      .adept
        margin 0
        height px2rem(96)
        overflow hidden
    .person-contact
      color white
    .person-contact ul
      margin 0
      padding 0
      list-style none
      width px2rem(516)
    .person-contact li
      line-height px2rem(35)
      width 33.333333%
      font-family: DINCondBold,Arial;
    .person-contact .phone, .qq, .wechat
      margin 0
      display inline-block
      ellipsis()
      line-height px2rem(22)
      font-size px2rem(24)
      max-width px2rem(120)
    .person-contact .iconfont
      line-height px2rem(35)
      font-size px2rem(35)
      margin-right px2rem(10)
    .person-contact .appointment
      width px2rem(165)
      height px2rem(35)
      border-radius px2rem(10)
      background-color #129FDD
      line-height px2rem(35)
      text-align center
      box-shadow 0 0 px2rem(4) 0 rgba(18,119,163,.75)
      margin-right px2rem(28)
      span
        font-size px2rem(20)
</style>



// WEBPACK FOOTER //
// person.vue?dc7982e0